var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"jetton-meta-price__change",class:_vm.getClassName},[_vm._v("\n        "+_vm._s(_vm.value)+"%\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }